import { useCallback, useMemo, useRef } from 'react';

import { useScreenState } from '@gogame/screens';

import { DIMENSION_TOTALS } from 'scenes/Trackers/Tracker/constants';
import { BREAK_DOWN_COLORS } from 'scenes/Trackers/components/colors';

export const useChartBreakdownColors = (rows) => {
  const screenState = useScreenState();
  const isChartBreakdownMode = useMemo(
    () => !!screenState.charts.find(({ breakdownMode }) => breakdownMode),
    [screenState.charts]
  );
  const maxTopItemsCount = Math.max(
    ...screenState.charts.map(({ breakdown }) => breakdown.topItemsCount || 0)
  );
  const colors = useMemo(
    () => BREAK_DOWN_COLORS.slice(0, maxTopItemsCount),
    [maxTopItemsCount]
  );
  const { offset } = screenState.tableSettings;
  const dimensionColorsMap = useRef({});

  useMemo(() => {
    if (rows && offset === 0) {
      dimensionColorsMap.current = rows
        .filter(({ Dimension }) => Dimension.id !== DIMENSION_TOTALS)
        .slice(0, maxTopItemsCount)
        .reduce((m, row, i) => {
          return {
            ...m,
            [row.id]: colors[i],
          };
        }, {});
    } else {
      dimensionColorsMap.current = {};
    }
  }, [rows, maxTopItemsCount, colors, offset]);

  const handleRowColor = useCallback(
    (rowData) => {
      const dimensionId = rowData?.id;
      return isChartBreakdownMode && dimensionColorsMap.current[dimensionId];
    },
    [colors, isChartBreakdownMode]
  );

  return {
    hasChartBreakdown: maxTopItemsCount > 0,
    breakdownColorGetter: handleRowColor,
  };
};
